<template>
  <div class="org-orders">
    <el-card>
      <div slot="header" class="card-header">
        <span>用户购买记录</span>
        <div class="header-filters">
          <el-select v-model="statusFilter" placeholder="订单状态" clearable style="width: 120px; margin-right: 10px" @change="loadOrders">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="待支付" :value="0"></el-option>
            <el-option label="已支付" :value="1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
          </el-select>
          <span v-if="filterUserName" class="filter-user">
            筛选用户: {{ filterUserName }}
            <el-button type="text" icon="el-icon-close" @click="clearUserFilter"></el-button>
          </span>
        </div>
      </div>

      <el-table :data="orderList" v-loading="loading" stripe>
        <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
        <el-table-column prop="username" label="用户名" width="120"></el-table-column>
        <el-table-column prop="courseType" label="课程类型" width="100"></el-table-column>
        <el-table-column prop="courseLevel" label="课程等级" width="100"></el-table-column>
        <el-table-column prop="amount" label="订单金额" width="100">
          <template slot-scope="scope">
            ¥{{ scope.row.amount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="payMethod" label="支付方式" width="100"></el-table-column>
        <el-table-column prop="payTime" label="支付时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.payTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="pageNum"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getOrgUserOrders } from '@/api/organization'
import { listAmcOrdersByUserId } from '@/api/amcOrder'

export default {
  name: 'OrgOrders',
  data() {
    return {
      orderList: [],
      loading: false,
      statusFilter: null,
      filterUserId: null,
      filterUserName: '',
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    // 从路由参数获取用户筛选
    if (this.$route.query.userId) {
      this.filterUserId = parseInt(this.$route.query.userId)
      this.filterUserName = this.$route.query.userName || ''
    }
    this.loadOrders()
  },
  methods: {
    async loadOrders() {
      this.loading = true
      try {
        if (this.filterUserId) {
          const res = await listAmcOrdersByUserId(this.filterUserId)
          if (res && res.code === 1) {
            let list = Array.isArray(res.data) ? res.data : []
            if (this.statusFilter !== null && this.statusFilter !== undefined) {
              list = list.filter(o => o && o.status === this.statusFilter)
            }
            this.orderList = list
            this.total = list.length
          }
        } else {
          const res = await getOrgUserOrders({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            userId: this.filterUserId,
            status: this.statusFilter
          })
          if (res && res.code === 1) {
            this.orderList = (res.data && res.data.records) || []
            this.total = (res.data && res.data.total) || 0
          }
        }
      } catch (e) {
        console.error('加载订单列表失败:', e)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.pageNum = 1
      this.loadOrders()
    },
    handlePageChange(page) {
      this.pageNum = page
      this.loadOrders()
    },
    clearUserFilter() {
      this.filterUserId = null
      this.filterUserName = ''
      this.$router.replace({ path: '/org/orders' })
      this.pageNum = 1
      this.loadOrders()
    },
    getStatusType(status) {
      const types = { 0: 'warning', 1: 'success', 2: 'info', 3: 'danger' }
      return types[status] || 'info'
    },
    getStatusText(status) {
      const texts = { 0: '待支付', 1: '已支付', 2: '已取消', 3: '已退款' }
      return texts[status] || '未知'
    },
    formatTime(time) {
      if (!time) return '-'
      if (typeof time === 'string') return time.replace('T', ' ').substring(0, 19)
      return time
    }
  }
}
</script>

<style scoped>
.org-orders {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-filters {
  display: flex;
  align-items: center;
}

.filter-user {
  background: #ecf5ff;
  padding: 5px 10px;
  border-radius: 4px;
  color: #409eff;
  font-size: 14px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
